import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "action-bar"
}

import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated, nextTick } from 'vue'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'
import { BrandCat } from '@/enums/brand'
import SelectBrand from '@/components/SelectBrand.vue'
import { beforeUpload, upload } from '@/utils/upload'
import { Plus } from '@element-plus/icons-vue'
import { isValidColor } from '@/utils/validator'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DailyDeliveryProduct',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const store = useStore()
    const state = reactive({
        user_id: store.state.user.userInfo.id,
        filters: {
            brand_id:       '',     // 品牌ID
            cat_id:         null,   // 品类ID
            product_name:     null,   // 商品
            status:         null,   // 状态
            page:           1,      // 当前页码
            page_size:      10,     // 每页显示条数
        },
        tableData:          [],     // 表单数据
        total:              0,      // 总条数
        brandList:          [],     // 品牌列表,用于搜索
        srcList:            [],     //头图预览
        dialogVisible:      false,  // 商品批量添加弹框
        dialogTableData:    [],     // 上传成功回显数据
    }) 
    const StyleConfig = reactive({
        img:           '',
        background:      '#fff',
        type:       2,
    })
    // 获取列表数据
    const getList = () => {
        proxy.$http.get(`/admin/products/get_daily_delivery_product_list?${joinParams(state.filters)}`).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            let tmpList = data.data || []
            tmpList.map(item => item.hasChildren = true)
            state.tableData = tmpList
            state.total = data.total || 0
        })
    }
    // 获取品牌列表
    const getBrandList = () => {
        proxy.$http.get(`/dsapi/trade/brands_list`).then(res => {
            const { code, data, msg, total } = res
            if (code != 200) return proxy.$message({ type: 'error', message: msg })
            state.brandList = data
        })
    }
    // 批量添加弹框关闭前清空数据
    const dialogBeforeClose = () => {
        nextTick(() => {
            proxy.$refs['StyleConfigRef'].clearValidate()
        })
        state.dialogVisible = false
        StyleConfig.img = ''
        StyleConfig.background = ''
        StyleConfig.type = ''
    }
    const updateRow = (row) => {
        proxy.$refs['StyleConfigRef'].validate((valid:boolean) => {
            if (valid) {
                if(!StyleConfig.img){
                    return proxy.$message({ type: 'error', message: '请添加头图' })
                }
                StyleConfig.type =1
                //调用风格配置接口
                proxy.$http.post('/admin/products/save_head_diagram',StyleConfig).then(res => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '保存成功' })
                    dialogBeforeClose()
                    getList()

                })
            }
        })
    }
    const onBeforeUpload= (file) => {
        return beforeUpload(file, {width:750})
    }
    // 图片上传事件
    const onImgUploadbrands = async(param) => {
        const res:any = await upload(param.file, {folderName: 'deliver'})
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        const { uid, img_info } = data
        const { id, o_path:url, file_name } = img_info
        let item = { id, url, file_name }
        StyleConfig.img = url
    }
    const onImg = () => {
        state.dialogVisible = true
        StyleConfig.type =2
         //调用风格配置接口
         proxy.$http.post('/admin/products/save_head_diagram',StyleConfig).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            StyleConfig.img = data.img
            StyleConfig.background = data.background
        })
    }
    //删除图片
    const removeLogoImage = (id) => {
        StyleConfig.img = '' 
    }
    const checkColor = (rule:any, val:any, callback:any) => {
        const { background } = StyleConfig
        if (!isValidColor(background)) {
            callback(new Error('请输入正确的颜色值eg:#ccc,#ec50ae'))
        } else {
            callback()
        }
    }
    const StockNum = (val) => {
        if(val<=0) {
            return val=1;
        }
    }
    const onBrandChange = (val) => {
        state.filters.brand_id = val
    }
    // 搜索
    const search = () => {
        state.filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        state.filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        state.filters.page_size = val
        getList()
    }
    const StyleConfigRules = reactive ({
        background: [
            { required: true, validator: checkColor, trigger: 'blur' }
        ],
    })
    //输入权重输入框失去焦点触发接口进行传值
    const handleBlur = async (row) => {
        const { id, artificial_sort } = row;

        try {
            // 发送权重更新请求
            const res = await proxy.$http.get('/admin/products/save_artificial', { id, artificial_sort });
            const { code, msg } = res;
            if (code != 200) {
                return proxy.$message({ type: 'error', message: msg });
            }

            proxy.$message({ type: 'success', message: msg });

            // 获取全部数据
            const allDataRes = await proxy.$http.get(`/admin/products/get_daily_delivery_product_list`);
            const { code: allDataCode, data: allData, msg: allDataMsg } = allDataRes;
            if (allDataCode != 200) {
                return proxy.$message({ type: 'error', message: allDataMsg });
            }

            if (allData.length > 0) {
                // 找到更新后的条目所在的页码
                const itemIndex = allData.findIndex(item => item.id === id);
                const newPage = Math.floor(itemIndex / state.filters.page_size) + 1;
                // 跳转到该页
                onPageChange(newPage);
            }
        } catch (error) {
            console.error('Error updating weight or fetching data:', error);
            proxy.$message({ type: 'error', message: '操作失败，请稍后重试' });
        }
    }
    getBrandList()
    getList()
    onActivated(() => {
        getList()
    })


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"margin-bottom":"25px"} }, "当日达提前预定时间≤5小时商品统计", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, {
        ifBody: 0,
        onBrandChange: onBrandChange
      }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: state.filters.product_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.filters.product_name) = $event)),
        placeholder: "商品名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: state.filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.filters.status) = $event)),
        placeholder: "商品状态",
        style: {"width":"170px"},
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "下架",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "上架",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (onImg()))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("风格配置")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: state.tableData,
      border: "",
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "product_id",
          label: "商品ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "商品名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx((scope) => [
            (scope.row.status == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "上架"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "下架"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "artificial_sort",
          label: "商品排序总权重",
          width: "160"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_input, {
              type: "number",
              modelValue: scope.row.artificial_sort,
              "onUpdate:modelValue": ($event: any) => ((scope.row.artificial_sort) = $event),
              placeholder: "请输入权重",
              min: 1,
              step: 1,
              onInput: ($event: any) => (scope.row.artificial_sort <0 || scope.row.artificial_sort.includes('.') ? scope.row.artificial_sort='':null),
              onBlur: ($event: any) => (handleBlur(scope.row)),
              title: StockNum(scope.row.artificial_sort) ? '权重必须大于0且不可输入小数':'',
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "onBlur", "title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: state.filters.page,
      total: state.total,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "风格配置",
      modelValue: state.dialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.dialogVisible) = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeClose }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (updateRow(StyleConfig)))
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: StyleConfig,
          ref: "StyleConfigRef",
          "label-width": "80px",
          rules: StyleConfigRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              class: "content-img-form-item",
              label: "头图配置",
              required: "",
              style: {"width":"380px"}
            }, {
              default: _withCtx(() => [
                (StyleConfig.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_el_image, {
                        class: "content-img",
                        src: StyleConfig.img,
                        fit: "scale-down",
                        "hide-on-click-modal": "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (state.srcList = [StyleConfig.img])),
                        "preview-src-list": state.srcList,
                        "append-to-body": "",
                        "z-index": 3000,
                        style: {"width":"150px"}
                      }, null, 8, ["src", "preview-src-list"])
                    ]))
                  : _createCommentVNode("", true),
                (StyleConfig.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("span", {
                        class: "color-primary",
                        style: {"cursor":"pointer"},
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (removeLogoImage(StyleConfig.id)))
                      }, "删除")
                    ]))
                  : _createCommentVNode("", true),
                (!StyleConfig.img)
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 2,
                      ref: "imageUpload",
                      class: "el-upload-list__item empty-item",
                      accept: ".jpg,.jpeg,.png",
                      action: "uploadUrl",
                      "before-upload": onBeforeUpload,
                      "http-request": onImgUploadbrands,
                      "show-file-list": false,
                      "list-type": "picture-card",
                      style: {"width":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tips" }, "注：限宽750", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "背景色",
              prop: "background"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: StyleConfig.background,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((StyleConfig.background) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "背景色",
                  maxlength: "7",
                  "show-word-limit": "",
                  style: {"width":"400px"},
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})